// extracted by mini-css-extract-plugin
export default {"title":"faa-z","warning":"gaa-z","sizeOptionsLegendText":"haa-z"};